<!--
    Styles
-->

<style>

    .ui-spinner svg {
        width: 100%;
        height: 100%;
        fill: var(--cl-blue);
        animation: ui-spinner 0.5s linear infinite;
    }

    @keyframes ui-spinner{
        100% {
            transform: rotate(360deg);
        }
    }

</style>



<!--
    Template
-->

<template>
    <div class="ui-spinner">
        <icon-spinner />
    </div>
</template>



<!--
    Scripts
-->

<script>


    import iconSpinner from '@/assets/icons/spinner.svg'


    export default {

        components: {
            iconSpinner
        }

    }

</script>

